"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var advertisements_1 = __importDefault(require("./advertisements"));
var template_1 = __importDefault(require("../helpers/template"));
var log_1 = __importDefault(require("../helpers/log"));
var utilities_1 = require("../helpers/utilities");
var Collection = /** @class */ (function () {
    function Collection() {
        this.config = {
            htmlElement: null,
            scrollPosition: 0,
            productsPerPage: window.theme.collection.productsPerPage,
            currentPage: null,
            totalProducts: null,
            items: {
                nodeList: null
            },
            productTiles: {
                nodeList: null,
            },
            advertisements: null,
            loadMoreBtn: {
                htmlInputElement: null
            },
            selectors: {
                main: '[data-collection-grid]',
                productTile: '[data-product-tile]',
                advertisement: '[data-advertisement]',
                loadMoreBtn: '[data-collection-grid-load-more-btn]',
                paginationCurrentlyDisplayed: '[data-pagination-currently-displayed]'
            }
        };
    }
    Collection.prototype.init = function () {
        var _this = this;
        document.querySelectorAll(this.config.selectors.main).forEach(function (htmlElement) {
            _this.load(htmlElement);
        });
    };
    Collection.prototype.load = function (htmlElement) {
        this.config.htmlElement = htmlElement;
        this.config.currentPage = window.theme.collection.pagination.currentPage;
        this.config.totalProducts = window.theme.collection.pagination.totalProducts;
        this.config.items.nodeList = this.config.htmlElement.querySelectorAll("".concat(this.config.selectors.productTile, ", ").concat(this.config.selectors.advertisement));
        this.config.productTiles.nodeList = this.config.htmlElement.querySelectorAll(this.config.selectors.productTile);
        this.config.loadMoreBtn.htmlInputElement = document.querySelector(this.config.selectors.loadMoreBtn);
        this.config.advertisements = window.theme.collection.advertisements;
        if (this.config.advertisements)
            advertisements_1.default.init(window.theme.collection.advertisements, this.config.currentPage);
        this.tidy();
        this.updatePagination();
        this.updateLoadMoreBtn();
        this.updateHeight();
        if (this.config.loadMoreBtn.htmlInputElement)
            this.config.loadMoreBtn.htmlInputElement.addEventListener('click', this.handleClickLoadMore.bind(this));
    };
    Collection.prototype.tidy = function () {
        var _this = this;
        this.config.htmlElement.querySelectorAll("".concat(this.config.selectors.productTile, ", ").concat(this.config.selectors.advertisement)).forEach(function (item, index) {
            item.classList.remove('hide');
            if (index >= _this.config.productsPerPage * _this.config.currentPage)
                item.classList.add('hide');
        });
    };
    Collection.prototype.updateLoadMoreBtn = function () {
        if (this.config.productTiles.nodeList.length == this.config.totalProducts || this.config.productTiles.nodeList.length === 0) {
            this.config.loadMoreBtn.htmlInputElement.closest('.row').classList.add('hide');
        }
    };
    Collection.prototype.updatePagination = function () {
        var shownProducts = Array.from(this.config.productTiles.nodeList).filter(function (node) { return !node.classList.contains('hide'); });
        document.querySelectorAll(this.config.selectors.paginationCurrentlyDisplayed).forEach(function (paginationCurrentlyDisplayedHtmlElement) {
            paginationCurrentlyDisplayedHtmlElement.textContent = String(shownProducts.length);
        });
    };
    Collection.prototype.update = function () {
        return __awaiter(this, void 0, void 0, function () {
            var error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.disableLoadMoreBtn();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        this.config.scrollPosition = window.scrollY;
                        return [4 /*yield*/, template_1.default.getAndAppendHTML({
                                node: this.config.htmlElement,
                                content: '[data-collection-grid-page]',
                                url: window.location.pathname + "?page=".concat(this.config.currentPage + 1),
                                view: 'product-tiles',
                                sortBy: (0, utilities_1.getParameterByName)('sort_by')
                            })];
                    case 2:
                        _a.sent();
                        this.config.items.nodeList = this.config.htmlElement.querySelectorAll("".concat(this.config.selectors.productTile, ", ").concat(this.config.selectors.advertisement));
                        this.config.productTiles.nodeList = this.config.htmlElement.querySelectorAll(this.config.selectors.productTile);
                        this.config.currentPage += 1;
                        if (this.config.advertisements)
                            advertisements_1.default.update(this.config.currentPage);
                        this.tidy();
                        this.updatePagination();
                        this.updateLoadMoreBtn();
                        this.enableLoadMoreBtn();
                        this.updateHeight();
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _a.sent();
                        log_1.default.error(error_1);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    Collection.prototype.updateHeight = function () {
        var _this = this;
        var imgs = this.config.htmlElement.querySelectorAll('img');
        imgs.forEach(function (img) { return img.addEventListener('load', function () {
            window.scrollTo(0, _this.config.scrollPosition);
        }); });
    };
    Collection.prototype.disableLoadMoreBtn = function () {
        this.config.loadMoreBtn.htmlInputElement.disabled = true;
        this.config.loadMoreBtn.htmlInputElement.classList.add('btn--loading');
    };
    Collection.prototype.enableLoadMoreBtn = function () {
        this.config.loadMoreBtn.htmlInputElement.disabled = false;
        this.config.loadMoreBtn.htmlInputElement.classList.remove('btn--loading');
    };
    Collection.prototype.handleClickLoadMore = function (event) {
        event.preventDefault();
        if (!this.config.loadMoreBtn.htmlInputElement.disabled)
            this.update();
    };
    return Collection;
}());
exports.default = new Collection();
